import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams , LoadingController, ModalController } from 'ionic-angular';

import { CarteraServiceProvider } from '../../providers/cartera-service/cartera-service';

import {BusquedaPage} from '../../pages/busqueda/busqueda'

import {AutoCompleteComponent} from 'ionic2-auto-complete';
import { EntidadServiceProvider} from '../../providers/entidad-service/entidad-service';

/**
 * Generated class for the DepartamentoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-departamento',
  templateUrl: 'departamento.html',
  providers: [EntidadServiceProvider ]
})
export class DepartamentoPage {

	@ViewChild('entidad') entidad: AutoCompleteComponent
	objdepartamento:any;  
	loading: any;
	detalleBusqueda: any;

  constructor(public navCtrl: NavController
  	, public navParams: NavParams
  	, public servicio:CarteraServiceProvider
  	, public loadingCtrl: LoadingController
  	, public modalCtrl: ModalController
  	, public entidadService: EntidadServiceProvider
  	) {

    this.entidadService.idtentidad = 2; //CONDOMINOS
    
  	this.objdepartamento={ id:0, idempresa:1, ndepartamento:'', codigo:''
  	, descripcion:'', ubicacion:'', npiso:''
  	, estado:0 , valalicuota:0
  	, identidad:0  ,idestado:0, entidad:'' };
  }

   showLoader(mensaje,tiempo){
 
        this.loading = this.loadingCtrl.create({
            content: mensaje,
            duration: tiempo,
            spinner: 'hide'
        });
 
        this.loading.present();

       this.loading.onDidDismiss(() => {
          
        });
    }

    botonNuevo(){
  	this.objdepartamento.id=0;
  	this.objdepartamento.descripcion='';
  	this.objdepartamento.ndepartamento='';
  	this.objdepartamento.ubicacion='';
  	this.objdepartamento.npiso='';
  	this.objdepartamento.codigo='';
  	this.objdepartamento.estado=0;
  	this.objdepartamento.valalicuota=0;
  	this.objdepartamento.identidad=0;
  	this.objdepartamento.entidad='';
  	this.entidad.setValue("");
  }
  botonGrabar(){
  	this.servicio.postDepartamento(this.objdepartamento).then((result) => 
  	{
  		console.log(result);
  		this.showLoader('Se guardó correctamente!!',1000);
  		this.botonNuevo();
  		
 	 },
 	  (err) => {
    	console.log(err);
    	alert(err);
  	 });
  }

  botonBuscar(){
  	this.servicio.getDepartamento().then((result) => {
  		this.detalleBusqueda={'parametro':result, 'campobus':'ndepartamento,codigo,entidad,valalicuota'};
  		let myModal = this.modalCtrl.create(BusquedaPage,this.detalleBusqueda);
  		myModal.onDidDismiss(data => {
        if (data != null) {

      		this.objdepartamento=data;
      		this.entidad.setValue(this.objdepartamento.entidad);
        }
  		});
    	myModal.present();
  	},
  	(err) => {
  		console.log(err);
  	});	
  }

  ionViewDidLoad() {
    
  }
  seleccionarEntidad(evento)
  {
  	this.entidad.setValue(evento.descripcion);
  	this.objdepartamento.identidad = evento.id;
  }

}



// WEBPACK FOOTER //
// ./src/pages/departamento/departamento.ts